import { render, staticRenderFns } from "./DialogoDeDetalhesDoTicket.vue?vue&type=template&id=c9ee89ac&scoped=true&"
import script from "./DialogoDeDetalhesDoTicket.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeDetalhesDoTicket.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeDetalhesDoTicket.vue?vue&type=style&index=0&id=c9ee89ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ee89ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VChip,VCol,VDialog,VRow,VSkeletonLoader})
